<!--
 * @Author       : panyangyang
 * @Date         : 2026-08-27 16:48:20
 * @LastEditTime : 2026-09-10 18:07:19
 * @LastEditors  : panyangyang
 * @Description  :
 * @FilePath     : \ngs_platform_manage_admin\src\views\large-screen\middle-panel\index.vue
-->
<template>
	<div class="center-panel">
		<!-- 顶部统计卡片 -->
		<div class="stat-card flex">
			<div class="flex">
				<span v-for="(item, index) in totalAmArr" :key="item + 'block' + index" class="single-block">
					<template v-if="item !== '.'">
						<!-- 数字滚动组件 -->
						<DigitRoll :value="Number(item)" :index="index" />
					</template>

					<!-- 小数点 -->
					<span v-else>{{ item }}</span>
				</span>
				<span class="unit">万元</span>
			</div>
			<div class="title">累计收入金额</div>
			<div class="underline"></div>
		</div>
		<!-- 统计卡片 -->
		<div class="stat-cards flex">
			<div v-for="(item, index) in statList" :key="index + 'statItem'" class="stat-item">
				<div class="stat-value">
					<span>{{ item.value }}</span>
					<span class="stat-unit"> {{ item.unit }}</span>
				</div>
				<div class="stat-title">{{ item.label }}</div>
			</div>
		</div>
		<!-- 在线人数 -->
		<div class="card center-bg3">
			<div class="card-header">在线人数</div>
			<div ref="onlineChart" class="chart-container"></div>
		</div>

		<!-- 即时收入 -->
		<div class="card center-bg4">
			<div class="card-header">即时收入</div>
			<div class="card-content">
				<vxe-grid ref="gridRef" class="transparent-grid" v-bind="gridOptions">
					<template #amount="{ row }">
						<span style="color: #F5B14C; font-weight: 600">{{ row.amount }}</span>
					</template>
				</vxe-grid>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import { debounce } from '@/utils/tools.js'
import DigitRoll from '../components/DigitRoll.vue'

export default {
	props: {
		// 中间数据
		middleData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	components: { DigitRoll },
	data() {
		return {
			amountInfo: {},
			totalAmArr: [], // 累计收入金额 数字转为数组
			statList: [
				{ alias: 'qyCount', value: 0, unit: '家', label: '累计新增企业' },
				{ alias: 'grCount', value: 0, unit: '人', label: '累计新增个人' },
				{ alias: 'zjCount', value: 0, unit: '人', label: '累计新增专家' },
				{ alias: 'ydCaCount', value: 0, unit: '个', label: '累计移动CA量' },
				{ alias: 'ahCaCount', value: 0, unit: '个', label: '累计安徽CA量' },
				{ alias: 'xmNum', value: 0, unit: '个', label: '累计招标项目' },
				{ alias: 'bdNum', value: 0, unit: '个', label: '累计标段数量' },
				{ alias: 'kbBdNum', value: 0, unit: '个', label: '累计开标数量' },
				{ alias: 'cjMoney', value: 0, unit: '万元', label: '累计成交金额' },
				{ alias: 'lbBdNum', value: 0, unit: '个', label: '累计流标数量' }
			],
			onlineArr: [], // 在线人数
			// 即时收入表格
			gridOptions: {
				size: 'mini',
				height: '100%',
				border: 'none',
				stripe: true,
				headerCellClassName: 'deep-color',
				showOverflow: true,
				showHeaderOverflow: false,
				cellConfig: {
					height: 36
				},
				headerCellConfig: {
					height: 30
				},
				columns: [
					{
						title: '收入类型',
						field: 'goodName',
						align: 'left',
						width: 300
					},
					{
						title: '金额',
						field: 'amount',
						align: 'left',
						width: 200,
						slots: { default: 'amount' }
					},
					{
						title: '支付人',
						field: 'createUser',
						align: 'left'
					},
					{
						title: '支付时间',
						field: 'payTime',
						align: 'left'
					}
				],
				data: []
			},
			charts: {},
			timmer: null
		}
	},
	created() {
		this.clearTimmer()
		this.showData()
	},
	mounted() {
		this.handleResize = debounce(() => {
			this.resizeCharts()
		}, 100)
		// 监听窗口尺寸变化
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy() {
		this.clearTimmer()
		window.removeEventListener('resize', this.handleResize)
		Object.values(this.charts).forEach((chart) => {
			if (chart) chart.dispose()
		})
	},
	methods: {
		// 回显数据
		showData() {
			const { amountInfo = {}, onlineArr = [], instantArr = [] } = this.middleData
			this.amountInfo = amountInfo

			this.totalAmArr = []

			if (this.amountInfo.hasOwnProperty('totalAm')) {
				this.totalAmArr = String(this.amountInfo.totalAm).split('') // 金额字符串转为数组
			}

			// 回显统计数据
			this.statList.forEach((item) => {
				if (this.amountInfo.hasOwnProperty(item.alias)) {
					item.value = this.amountInfo[item.alias] || 0
				} else {
					item.value = 0
				}
			})

			this.onlineArr = onlineArr // 在线人数
			this.gridOptions.data = instantArr // 即时收入

			setTimeout(() => {
				// 表格赋值后 开启表格滚动定时器
				this.startTimmer()
				// 初始化图表
				this.initCharts()
			}, 200)
		},

		// 开启表格滚动定时器
		startTimmer() {
			const els = this.$refs.gridRef?.$el?.getElementsByClassName('vxe-table--body-wrapper')

			if (!els || els.length === 0) return

			const wrapper = els[0]

			// 没有滚动区域时，不开启定时器  内容高度大于容器高度，即存在滚动区域
			if (wrapper.scrollHeight <= wrapper.clientHeight) {
				return
			}

			// 避免重复开启定时器
			if (this.timmer) {
				clearInterval(this.timmer)
			}

			this.timmer = setInterval(() => {
				const isBottom = wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - 1

				if (isBottom) {
					// 滚动到底部后回到顶部
					wrapper.scrollTop = 0
				} else {
					// 每次滚动 1 像素
					wrapper.scrollTop += 1
				}
			}, 100)
		},

		// 初始化图表
		initCharts() {
			this.initOnlineChart()
		},

		// 在线人数折线图
		initOnlineChart() {
			const chart = echarts.init(this.$refs.onlineChart)
			let names = []
			let values = []
			this.onlineArr.map((i) => {
				names.push(i.name)
				values.push(i.value)
			})
			const option = {
				tooltip: {
					trigger: 'axis'
				},
				color: ['#4BDE80'],
				grid: { left: '3%', right: '4%', bottom: '5%', top: '10%', containLabel: true },

				xAxis: {
					type: 'category',
					axisLabel: {
						color: '#C5DCFF'
					},
					axisTick: {
						show: false
					},
					data: names
				},
				yAxis: {
					type: 'value',
					minInterval: 1, // 防止自动计算出小数间隔
					// 如果最大值是动态的，可以自动向上取整
					max: function(value) {
						return Math.ceil(value.max)
					},
					axisLabel: {
						color: '#C5DCFF'
					},
					splitLine: {
						lineStyle: {
							color: '#39A1FF'
							// 或使用 rgba(255,107,107,0.3) 半透明
						}
					}
				},
				series: [
					// 底层模糊线
					{
						name: '模糊线',
						type: 'line',
						data: values,
						smooth: false,
						symbol: 'none',
						silent: true,
						z: 1,
						tooltip: {
							show: false
						},
						lineStyle: {
							color: 'rgba(40, 255, 130, 0.92)',
							// width: 5, // 底层模糊线的宽度
							shadowBlur: 8, // 模糊程度
							shadowColor: 'rgba(30, 255, 130, 0.8)', // 模糊线颜色
							shadowOffsetY: 12 // 向下偏移的像素值
						}
					},

					// 上层主折线
					{
						name: '在线人数',
						type: 'line',
						data: values,
						smooth: false,
						symbol: 'circle',
						z: 2,
						// lineStyle: {
						// 	color: '#5cff91',
						// 	width: 0.1
						// },
						itemStyle: {
							color: '#66ff9b',
							borderColor: '#d8ffe4',
							borderWidth: 2,
							shadowBlur: 8,
							shadowColor: '#45ff87'
						},
						emphasis: {
							focus: 'series'
						}
					}
				]
			}
			chart.setOption(option)
			this.charts.trend = chart
		},
		// 窗口大小变化时重置图表
		resizeCharts() {
			Object.values(this.charts).forEach((chart) => {
				if (chart) chart.resize()
			})
		},

		// 清除定时器
		clearTimmer() {
			clearInterval(this.timmer)
			this.timmer = null
		}
	},
	watch: {
		// 监听数据改变
		middleData: {
			deep: true,
			handler() {
				this.showData()
			}
		}
	}
}
</script>

<style lang="less" scoped>
// 文字颜色渐变
.text-gradient {
	background-image: linear-gradient(to bottom, #76b6f5 0%, #edf4fc 100%);
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
}
// 背景图设置
.image-set {
	background-size: 100% 100%;
	background-repeat: no-repeat;
}

.center-panel {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-height: 0;
}

// 中间区域-顶部统计
.stat-card {
	width: 100%;
	height: 16%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 19px;
	padding-top: 20px;
	background-image: url('~@/assets/images/screen/center-bg1.png');
	.image-set;

	.single-block {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 40px;
		height: 60px;
		font-size: 44px;
		color: #f5b14c;
		margin-right: 8px;
		background-image: url('~@/assets/images/screen/center-bg5.png');
		.image-set;
	}

	.unit {
		display: flex;
		align-items: end;
		font-size: 14px;
		color: #c5dcff;
	}

	.title {
		font-weight: 600;
		font-size: 18px;
		margin-top: 8px;
		.text-gradient;
	}

	.underline {
		width: 400px;
		height: 6px;
		margin-top: 5px;
		background-image: url('~@/assets/images/screen/underline.png');
		.image-set;
	}
}

// 统计卡片
.stat-cards {
	width: 100%;
	height: 20%;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;

	.stat-item {
		width: 166px;
		height: calc(50% - 5px);
		// height: 80px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		// padding-top: 16px;
		margin-right: 10px;
		margin-bottom: 10px;
		background-image: url('~@/assets/images/screen/center-bg2.png');
		.image-set;

		&:nth-child(5n) {
			margin-right: 0;
		}
		.stat-value {
			color: #ffffff;
			font-size: 26px;
		}
		.stat-unit {
			font-size: 14px;
			color: #c5dcff;
		}
		.stat-title {
			font-size: 14px;
			color: #60adf9;
		}
	}
}
// 在线人数
.center-bg3 {
	width: 100%;
	height: 26%;
	// height: 260px;
	background-image: url('~@/assets/images/screen/center-bg3.png');
	.image-set;
}
// 即时收入
.center-bg4 {
	width: 100%;
	height: 40%;
	// height: 363px;
	background-image: url('~@/assets/images/screen/center-bg4.png');
	.image-set;
}

// 自定义表格背景色 transparent-grid
.transparent {
	background: transparent !important;
	background-color: transparent !important;
}

/deep/ .vxe-grid {
	.transparent;

	.vxe-table--render-wrapper {
		background: transparent !important;
		background-color: transparent !important;
		color: #c5dcff !important;
	}

	.vxe-table--render-default.border--inner .vxe-table--header-wrapper,
	.vxe-table--render-default.border--none .vxe-table--header-wrapper,
	.vxe-table--render-default .vxe-table--body-wrapper table,
	.vxe-table--render-default .vxe-table--footer-wrapper table {
		color: #c5dcff !important;
		background: transparent !important;
		background-color: transparent !important;
	}

	// 去除所有边框
	&::before,
	&::after {
		display: none;
	}

	// 设置表头单元格
	tr,
	th {
		background-color: transparent !important;
		border: none !important;

		&::before {
			display: none;
		}

		&.vxe-body--row {
			color: #c5dcff !important;
			background: rgba(59, 161, 255, 0.14) !important;
		}

		&.vxe-body--row.row--stripe {
			background: none !important;
		}
	}

	// 设置表体单元格
	td {
		background-color: transparent !important;
		border: none !important;
		font-size: 14px !important;
		height: 32px !important;
	}

	// 去除行悬停效果
	.vxe-body--row {
		&:hover {
			td {
				background-color: transparent !important;
			}
		}
	}
}
</style>
